import Enum from 'enum'
import nacl from 'tweetnacl'
import naclUtil from 'tweetnacl-util'

export function highlight (haystack, needle) {
  return haystack.replace(RegExp(needle, 'gi'), (a, b) => {
    return '<mark>' + a + '</mark>'
  })
}

export const deviceType = new Enum({
  Desktop: 1,
  // Tablet: 2,
  Phone: 3,
  Image: 11
})

export const companyType = process.env.VUE_APP_COMPANY_TYPE
export const adminEmail = process.env.VUE_APP_ADMIN_EMAIL

export function encrypt (data, key) {
  function padEnd (string, targetLength, padString) {
    string = String(string)
    targetLength = targetLength >> 0
    padString = String((typeof padString !== 'undefined' ? padString : ' '))
    if (string.length > targetLength) {
      return string.slice(0, 32)
    } else {
      targetLength = targetLength - string.length
      if (targetLength > padString.length) {
        padString += padString.repeat(targetLength / padString.length)
      }
      return string + padString.slice(0, targetLength)
    }
  }

  function textEncode (str) {
    if (window.TextEncoder) {
      return new TextEncoder('utf-8').encode(str)
    }
    let utf8 = unescape(encodeURIComponent(str))
    let result = new Uint8Array(utf8.length)
    for (let i = 0; i < utf8.length; i++) {
      result[i] = utf8.charCodeAt(i)
    }
    return result
  }

  const encodeBase64 = naclUtil.encodeBase64
  const nonce = nacl.randomBytes(24)
  const secretKey = textEncode(padEnd(key, 32, '0'))
  const secretData = textEncode(data)
  const encrypted = nacl.secretbox(secretData, nonce, secretKey)
  return `${encodeBase64(nonce)}:${encodeBase64(encrypted)}`
}



// WEBPACK FOOTER //
// ./src/lib/utils.js